import { render, staticRenderFns } from "./CollectWriteDefaultLayout.vue?vue&type=template&id=66ebbfbc&scoped=true&"
import script from "./CollectWriteDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./CollectWriteDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ebbfbc",
  null
  
)

export default component.exports